<script setup lang="ts">
import { onMounted } from 'vue';
import useFlowNavigation from '@Use/useFlowNavigation';
import { verifyUserApi } from '@Api/activitySession.api';
import { markRequestAsStartedApi } from '@Api/requestFlow.api';
import { createMobileSessionApi } from '@Api/idv.api';
import { useRequestSessionStore } from '@Stores/requestSession.store';
import { writeMintedQrSessionToken } from '@Stores/requestSessionStore.utils';
import { RequestType } from '@Enums/requestType.enum';

const { advanceFlowReplace } = useFlowNavigation();

onMounted(async () => {
    await bootstrapMfe();
});


// First, invisible page, of mfe flow where auth will be required
const bootstrapMfe = async () => {
    await verifyUserApi();

    const requestSessionStore = useRequestSessionStore();
    if (requestSessionStore.requestSummary?.requestType === RequestType.Identity) {
        try {
            const session = await createMobileSessionApi();
            requestSessionStore.setQrSessionToken(session?.qrSessionToken ?? null);
        } catch (error) {
            console.warn('[Request MFE] Failed to create mobile session — continuing:', error);
        }

        // PS-1169: remember what this device minted, so the Intellicheck capture return
        // carrying the same token back is not mistaken for a QR scan. Kept out of the block
        // above so a storage failure logs as a storage failure: it reverts this device to
        // the PS-1169 misclassification, which is worth its own line in the console.
        if (requestSessionStore.qrSessionToken) {
            try {
                writeMintedQrSessionToken(requestSessionStore.qrSessionToken);
            } catch (error) {
                console.warn('[Request MFE] Failed to record minted QR session token:', error);
            }
        }
    }

    await markRequestAsStartedApi();
    advanceFlowReplace();
};

</script>


<template>
    <app-page-loader />
</template>